import { render, staticRenderFns } from "./NewRequestBookings.vue?vue&type=template&id=6baec6e1&"
import script from "./NewRequestBookings.vue?vue&type=script&lang=js&"
export * from "./NewRequestBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6baec6e1')) {
      api.createRecord('6baec6e1', component.options)
    } else {
      api.reload('6baec6e1', component.options)
    }
    module.hot.accept("./NewRequestBookings.vue?vue&type=template&id=6baec6e1&", function () {
      api.rerender('6baec6e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/NewRequestBookings.vue"
export default component.exports